import Vue from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue.js?vue3';
import VueApollo from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/vue_apollo.js?vue3';
import { initVueApp } from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/utils/vue3compat/init_vue_app.js?vue3';
import createDefaultClient from '/builds/gitlab/gitlab-ee/app/assets/javascripts/lib/graphql.js?vue3';
import CommitBranches from '/builds/gitlab/gitlab-ee/app/assets/javascripts/projects/commit_box/info/components/commit_refs.vue?vue3';

Vue.use(VueApollo);

const apolloProvider = new VueApollo({
  defaultClient: createDefaultClient(),
});

export default (selector = 'js-commit-branches-and-tags') => {
  const el = document.getElementById(selector);

  if (!el) {
    return false;
  }

  const { fullPath, commitSha } = el.dataset;

  return initVueApp({
    el,
    name: 'CommitBranchesRoot',
    apolloProvider,
    provide: {
      fullPath,
      commitSha,
    },
    component: CommitBranches,
  });
};
